module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_edu"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.education))]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.backgroundColumn,
      "data": _vm.teacher.background
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.course))]), _vm._v(" "), _vm._l((_vm.teacher.course), function(course, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showCourse(course)))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9f2fd38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeacherEdu.vue
// module id = 1283
// module chunks = 4